import { lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./i18n";
import "./App.css";

const PrivacyPolicy = lazy(() => import("./components/PrivacyAndPolicy"));
const Home = lazy(() => import("./components/Home"));

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/uls-leziria" element={<PrivacyPolicy />} />
        <Route path="/sigame" element={<PrivacyPolicy />} />
        <Route path="/ipoporto" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
